export default __webpack_public_path__ + "static/media/640_store04-en-mobile.40ef1444.png";